const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.min';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectMultiple: $('.js-select-multiple'),

	/** @description Initialize */
	init: function() {
		this.select2();
		this.select2Multiple();
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class',
			placeholder: '',
		});
	},

	select2Multiple: function() {
		Select2.$selectMultiple.select2({
			width: '100%',
			/* closeOnSelect: false, */
			// allowHtml: true,
			// allowClear: true,
			// tags: true
		});
	}
};

export default Select2;
